import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Merges class names, letting a caller override a component's own utilities.
 *
 * Plain concatenation would leave `px-4 px-8` in the markup and hand the
 * decision to whichever rule Tailwind happened to emit last, which is not a
 * decision anybody made.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
